// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  margin-top: 10px;
}

.logo {
  max-width: 100%;
  max-height: 64px;
  object-fit: contain;
}

.info {
  font-size: 12px;
  margin-top: 5px;
  text-align: center;
}

.az-sidebar {
  padding-top: 10px;
}

.az-footer {
  background-color: white !important;
  position: fixed;
  bottom: 10px;
  width: 239px;
}

@media only screen and (max-width: 1199px) {
  .az-footer {
    width: 219px;
  }
}
.username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 130px;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNpZGViYXIuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDSSxnQkFBQTtBQUNKOztBQUNBO0VBQ0ksZUFBQTtFQUNBLGdCQUFBO0VBQ0EsbUJBQUE7QUFFSjs7QUFBQTtFQUNJLGVBQUE7RUFDQSxlQUFBO0VBQ0Esa0JBQUE7QUFHSjs7QUFBQTtFQUNFLGlCQUFBO0FBR0Y7O0FBQUE7RUFDSSxrQ0FBQTtFQUNBLGVBQUE7RUFDQSxZQUFBO0VBQ0EsWUFBQTtBQUdKOztBQURBO0VBQ0k7SUFDSSxZQUFBO0VBSU47QUFDRjtBQURBO0VBQ0ksZ0JBQUE7RUFDQSx1QkFBQTtFQUNBLG1CQUFBO0VBQ0EsY0FBQTtFQUNBLFlBQUE7QUFHSiIsImZpbGUiOiJzaWRlYmFyLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmZvb3RlciB7XG4gICAgbWFyZ2luLXRvcDogMTBweFxufVxuLmxvZ28ge1xuICAgIG1heC13aWR0aDoxMDAlO1xuICAgIG1heC1oZWlnaHQ6NjRweDtcbiAgICBvYmplY3QtZml0OiBjb250YWluO1xufVxuLmluZm8ge1xuICAgIGZvbnQtc2l6ZTogMTJweDtcbiAgICBtYXJnaW4tdG9wOiA1cHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xufVxuXG4uYXotc2lkZWJhciB7XG4gIHBhZGRpbmctdG9wOiAxMHB4O1xufVxuXG4uYXotZm9vdGVyIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB3aGl0ZSAhaW1wb3J0YW50O1xuICAgIHBvc2l0aW9uOmZpeGVkO1xuICAgIGJvdHRvbTogMTBweDtcbiAgICB3aWR0aDogMjM5cHg7IFxufVxuQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAobWF4LXdpZHRoOiAxMTk5cHgpIHtcbiAgICAuYXotZm9vdGVyIHtcbiAgICAgICAgd2lkdGg6IDIxOXB4O1xuICAgIH1cbn1cblxuLnVzZXJuYW1lIHtcbiAgICBvdmVyZmxvdzogaGlkZGVuO1xuICAgIHRleHQtb3ZlcmZsb3c6IGVsbGlwc2lzO1xuICAgIHdoaXRlLXNwYWNlOiBub3dyYXA7XG4gICAgZGlzcGxheTogYmxvY2s7XG4gICAgd2lkdGg6IDEzMHB4O1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/sidebar/sidebar.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AACA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;;AAAA;EACI,eAAA;EACA,eAAA;EACA,kBAAA;AAGJ;;AAAA;EACE,iBAAA;AAGF;;AAAA;EACI,kCAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAGJ;;AADA;EACI;IACI,YAAA;EAIN;AACF;AADA;EACI,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;AAGJ;AACA,o2CAAo2C","sourcesContent":[".footer {\n    margin-top: 10px\n}\n.logo {\n    max-width:100%;\n    max-height:64px;\n    object-fit: contain;\n}\n.info {\n    font-size: 12px;\n    margin-top: 5px;\n    text-align: center;\n}\n\n.az-sidebar {\n  padding-top: 10px;\n}\n\n.az-footer {\n    background-color: white !important;\n    position:fixed;\n    bottom: 10px;\n    width: 239px; \n}\n@media only screen and (max-width: 1199px) {\n    .az-footer {\n        width: 219px;\n    }\n}\n\n.username {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    display: block;\n    width: 130px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
